module.exports = __webpack_public_path__ + "img/52114114_L.99891f34.png";